import React from 'react';
import MessageThreadItem from '../../Components/MessageThreadItem';
import ThreadMainMessageButtons from '../../Components/ThreadMainMessageButtons';
import { MessageStatistics } from '../../Components/MessageStatistics';
import ThreadMainMessagePropType from '../../PropTypes/ThreadMainMessagePropType';
import AttachmentsPreview from '../../Components/AttachmentsPreview';
import MessageThreadReply from '../../Components/MessageThreadReply';
import './index.sass';

const ThreadMainMessage = ({
  saveAsTemplate,
  messageHtml,
  messagePublicId,
  userImage,
  onStatisticsModalCall,
  date,
  showButtons = true,
  onStatisticsToggle,
  activeStatistics,
  statisticsThreadMessages,
  onForward,
  onPreview,
  onResend,
  userName,
  isUncertainMessage,
  isDirect,
  files,
  replyMessage,
  threadMainMessage,
}) => {
  return (
    <div id="message-view">
      <MessageThreadItem
        rtl={!isUncertainMessage}
        highlighted={!userName}
        fullWidth
        userName={userName}
        messageHtml={messageHtml}
        userImage={userImage}
        date={date}
      />

      {isUncertainMessage && (
        <MessageThreadReply
          counter={threadMainMessage.responseMessages && threadMainMessage.responseMessages.length}
          userImage={userImage}
          date={date}
          hideReplyButton={false}
          onReply={() => replyMessage(threadMainMessage)}
        />
      )}

      {files && files.length > 0 && (
        <AttachmentsPreview files={files} />
      )}

      {showButtons && (
        <ThreadMainMessageButtons
          isResendUnopened={!isDirect}
          isStatistics={activeStatistics}
          onForwardClick={onForward}
          onHistoryClick={onPreview}
          onResend={onResend}
          onTemplateClick={saveAsTemplate}
          onStatisticsClick={onStatisticsToggle}
        />
      )}
      {activeStatistics && statisticsThreadMessages && (
        <MessageStatistics
          publicId={messagePublicId}
          data={statisticsThreadMessages}
          onClose={onStatisticsToggle}
          onStatisticsModalCall={onStatisticsModalCall}
        />
      )}
    </div>
  );
};

export default ThreadMainMessage;

ThreadMainMessage.propTypes = ThreadMainMessagePropType;

ThreadMainMessage.defaultProps = {
  userImage: null,
  isUncertainMessage: false,
  isDirect: false,
  files: [],
  showButtons: false,
  activeStatistics: false,
  statisticsThreadMessages: null,
  userName: null,
};
